export default __webpack_public_path__ + "29cc40e02fe7bbcdb3d02b5f5722ca7e.svg";